<script setup lang="ts">
interface IProps {
    count?: number;
    fromScale?: string;
    toScale?: string;
}
const {
    fromScale = 'scale(1, 1)',
    toScale = 'scale(1.5, 1.5)',
    count = 3,
} = defineProps<IProps>();
</script>

<template>
    <div :style="{ '--to-scale': toScale, '--from-scale': fromScale }">
        <div v-for="w in count" :key="w" class="wave_ring" />
    </div>
</template>

<style lang="scss" scoped>
.wave_ring {
    border: 1px solid usePalette();
    border-radius: 12px;
    inset: 0;
    position: absolute;
    animation: pulsate 1.4s ease-out;
    animation-iteration-count: infinite;
    opacity: 0;
    z-index: 10;
    &:nth-child(1) {
        animation-delay: 0.5s;
    }
    &:nth-child(2) {
        animation-delay: 1s;
    }
    &:nth-child(3) {
        animation-delay: 1.5s;
    }
    &:nth-child(4) {
        animation-delay: 2s;
    }
}
@keyframes pulsate {
    0% {
        transform: var(--from-scale);
        opacity: 0;
    }
    50% {
        opacity: 1;
    }
    100% {
        transform: var(--to-scale);
        opacity: 0;
    }
}
</style>
